/* eslint-disable indent */
/* eslint-disable react/no-array-index-key */
import { useState } from "react";
import styled from "styled-components";
import Link from "next/link";
import CircleWithLine from "../../assets/svgs/CircleWithLine";
import { Section, Container, Row } from "../../styles/commonStyles";
import CITY_COMPONENT_DATA from "../../cms/city-data";
import JOB_DETAILS from "../../cms/category-data";
import { getUrlPath } from "../../utils/helpers";
import { mediaMaxWidth } from "../../utils/mediaQuery";
import Mixpanel from "../../utils/Mixpanel";
// Constants
const MAX_ITEMS_TO_SHOW = 12;

const Chips = ({ text, url, city, area, source }) => {
	const trackChipClick = () => {
		Mixpanel.track("Job Category Chip Click", {
			title: text,
			Source: source,
			city,
			area,
			page: getUrlPath(),
		});
	};

	return (
		// eslint-disable-next-line react/jsx-no-useless-fragment
		<>
			{url ? (
				<Link href={url} passHref>
					<ChipsContainer onClick={trackChipClick} as="a" href={url}>
						<ChipsText>{text}</ChipsText>
					</ChipsContainer>
				</Link>
			) : (
				<ChipsContainer>
					<ChipsText>{text}</ChipsText>
				</ChipsContainer>
			)}
		</>
	);
};

const JobTypesSection = ({ city, cityId, area, noMargin, source }) => {
	const [itemsToShow, setItemsToShow] = useState(MAX_ITEMS_TO_SHOW);
	const [jobs] = useState(Object.assign([], JOB_DETAILS));
	const [cities] = useState(Object.assign([], CITY_COMPONENT_DATA));
	const [expanded, setExpanded] = useState(false);

	const handleClick = () => {
		if (itemsToShow === MAX_ITEMS_TO_SHOW) {
			setItemsToShow(jobs.length);
			setExpanded(true);
		} else {
			setItemsToShow(MAX_ITEMS_TO_SHOW);
			setExpanded(false);
		}
	};

	return (
		<SectionContainer bgColor="#4d3951">
			<Container>
				<Row>
					<SectionHeading noMargin={noMargin}>
						Jobs available in <span>200+ categories</span> including
					</SectionHeading>
				</Row>
				<RowWrapper>
					{jobs.slice(0, itemsToShow).map((data, index) => (
						<Chips
							text={data.type}
							key={index}
							city={city}
							area={area}
							source={source}
							url={
								city && cityId
									? `/jobs/${data.slug}-jobs-in-${city
											.toLowerCase()
											.replace("-", "_")}`
									: `/jobs/${data.slug}-jobs`
							}
						/>
					))}
					<ShowMoreButton id="show-more-jobs-btn" onClick={handleClick}>
						{expanded
							? "Show less"
							: `+ ${jobs.length - MAX_ITEMS_TO_SHOW} more`}
					</ShowMoreButton>
				</RowWrapper>
			</Container>
			<Container>
				<Row>
					<SectionHeading noMargin={noMargin}>
						Find Jobs in
						<span>{` ${CITY_COMPONENT_DATA?.length || 7} Cities`}</span>
					</SectionHeading>
				</Row>
				<RowWrapper>
					{cities.map((data) => (
						<Chips
							text={data.name}
							key={data.id}
							url={`/jobs/jobs-in-${data.slug}`}
						/>
					))}
				</RowWrapper>
			</Container>
			<BackgroundShapeContainer>
				<CircleWithLine />
			</BackgroundShapeContainer>
		</SectionContainer>
	);
};

// Styles
const SectionContainer = styled(Section)`
	position: relative;
	overflow: hidden;
	padding: 40px 0;
`;
const SectionHeading = styled.h3`
	font-size: 32px;
	font-weight: 300;
	line-height: 1.38;
	text-align: center;
	color: #ffffff;
	width: 100%;
	margin-top: ${(props) => (props.noMargin ? "0px" : "50px")};
	& span {
		font-weight: 900;
	}
`;
const RowWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap;
	position: relative;
	z-index: 2;
`;
const ChipsContainer = styled.div`
	border-radius: 24px;
	background-color: #6c5271;
	text-align: center;
	padding: 10px 15px;
	margin-right: 10px;
	margin-bottom: 10px;
	min-width: 125px;
	max-width: 370px;
	text-decoration: none;
	display: block;
	color: #fff;

	&:hover {
		text-decoration: ${({ as }) => (as === "a" ? "underline" : "none")};
	}
`;
const ChipsText = styled.div`
	font-size: 20px;
	color: #ffffff;
`;
const ShowMoreButton = styled(ChipsContainer)`
	cursor: pointer;
	color: #4d3951;
	background-color: #fff;
`;

const BackgroundShapeContainer = styled.div`
	width: 206px;
	height: 206px;
	position: absolute;
	top: 70px;
	right: -90px;
	transform: scale(1.5) rotate(-35deg);
	opacity: 0.1;
	mix-blend-mode: screen;

	${mediaMaxWidth.medium`
        top: 50%;
    `};
`;

export default JobTypesSection;
